<template>
  <div class="col-sm-12 nopads pt-3 pb-3">
    <div class="row">
      <span class="tip-light">{{ $t('contracts.external.equipment_hint') }}</span>
    </div>
    <div class="row">
        <div
            class="form-check form-check-inline"
            v-for="equipment in equipments"
            :key="equipment.value"
        >
            <input
                class="form-check-input"
                type="checkbox"
                :id="`equipment-${equipment.value}`"
                :value="equipment.value"
                :disabled="equipment.notEnabled"
                v-model="selected"
            />
            <label class="form-check-label" :for="`equipment-${equipment.value}`">
                {{ equipment.text }}
            </label>
        </div>
    </div>
  </div>
</template>

<script>
import {mapHelper} from "@/components/mixins/MapMixin";

export default {
    name: 'ContractEquipmentFilter',
    mixins: [mapHelper],
    data: function () {
        return {
            loading: false,
            equipments: [],
            selected: []
        }
    },
    watch: {
        selected: function () {
            this.$emit('equipmentSelected', this.selected)
        }
    },
    mounted() {
        this.equipments = [
            {text: this.$t("external_road_signs.road_signs"), value: this.EXTERNAL_TRAFFIC_SIGNS},
            {text: this.$t("infra.posts"), value: this.EXTERNAL_POSTS},
            {text: this.$t("culvert.title"), value: this.EXTERNAL_CULVERTS},
            {text: this.$t("railing.title"), value: this.EXTERNAL_RAILINGS},
            {text: this.$t("portal.title"), value: this.EXTERNAL_PORTALS}
        ]
    }
}
</script>
